var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 8.66667C13.3334 12 11.0001 13.6667 8.22675 14.6333C8.08152 14.6826 7.92377 14.6802 7.78008 14.6267C5.00008 13.6667 2.66675 12 2.66675 8.66667V4C2.66675 3.82319 2.73699 3.65362 2.86201 3.5286C2.98703 3.40358 3.1566 3.33334 3.33341 3.33334C4.66675 3.33334 6.33341 2.53334 7.49341 1.52C7.63465 1.39934 7.81432 1.33304 8.00008 1.33304C8.18585 1.33304 8.36551 1.39934 8.50675 1.52C9.67342 2.54 11.3334 3.33334 12.6667 3.33334C12.8436 3.33334 13.0131 3.40358 13.1382 3.5286C13.2632 3.65362 13.3334 3.82319 13.3334 4V8.66667Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/Security.b45ea4bb29810407dbd0cea29baa7159.svg";
export { ForwardRef as ReactComponent };